var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTogelTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 33 33",
    height: 300,
    viewBox: "0 0 33 33",
    width: 300,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m16.5 32.5c-4.273 0-8.292-1.665-11.313-4.688-3.023-3.021-4.687-7.039-4.687-11.313 0-4.273 1.664-8.292 4.686-11.313 3.022-3.022 7.04-4.686 11.314-4.686 8.823 0 16 7.177 16 15.999 0 8.823-7.178 16.001-16 16.001zm0-30.118c-3.771 0-7.316 1.469-9.983 4.136-2.667 2.666-4.135 6.211-4.134 9.981 0 3.771 1.468 7.316 4.134 9.982 2.667 2.667 6.212 4.136 9.983 4.136 7.784 0 14.118-6.333 14.118-14.118-.001-7.784-6.335-14.117-14.118-14.117z",
    fill: "#a6a6a6",
    fillOpacity: 1,
    "data-original-color": "#414042ff",
    stroke: "none",
    strokeOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#808285"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.5 7.559c-4.93 0-8.941 4.011-8.941 8.94 0 4.931 4.011 8.941 8.941 8.941s8.942-4.011 8.942-8.941c-.001-4.93-4.012-8.94-8.942-8.94zm0 15.999c-3.893 0-7.059-3.166-7.059-7.059 0-3.892 3.167-7.058 7.059-7.058 3.893 0 7.059 3.166 7.059 7.058 0 3.893-3.166 7.059-7.059 7.059z",
    fill: "#a6a6a6",
    fillOpacity: 1,
    "data-original-color": "#808285ff",
    stroke: "none",
    strokeOpacity: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.611 16.088c.379-.469.613-1.056.613-1.702 0-1.503-1.223-2.726-2.725-2.726-1.503 0-2.726 1.223-2.726 2.726 0 .646.236 1.233.613 1.702-.578.556-.941 1.333-.941 2.196 0 1.684 1.37 3.054 3.054 3.054s3.053-1.37 3.053-3.054c.001-.863-.363-1.64-.941-2.196zm-2.955-1.702c0-.465.379-.843.844-.843.466 0 .844.378.844.843s-.378.844-.844.844c-.465-.001-.844-.379-.844-.844zm.844 5.07c-.646 0-1.172-.526-1.172-1.172s.526-1.172 1.172-1.172c.645 0 1.172.525 1.172 1.172 0 .646-.527 1.172-1.172 1.172z",
    fill: "#a6a6a6",
    fillOpacity: 1,
    "data-original-color": "#808285ff",
    stroke: "none",
    strokeOpacity: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTogelTop);
export default __webpack_public_path__ + "static/media/togelTop.77800478859fa0f40a9d9a3f4bf4df3a.svg";
export { ForwardRef as ReactComponent };